import React from 'react';
import { Fab, Fade, useTheme } from '@mui/material';

import useSettings from '../../hooks/useSettings';
import { type DetailsButtonProps } from './DetailsPage';
import Icon from '../../Icon';
import PageFab, { type FabType } from '../components/PageFab';

interface DetailsPageFabProps {
	fab: FabType<DetailsButtonProps>;
	fabProps: DetailsButtonProps;
	currentTabId?: string;
	isEdit: boolean;
	isAdd: boolean;
}

export default function DetailsPageFabs(props: DetailsPageFabProps) {
	const { t } = useSettings();
	const theme = useTheme();

	const transitionDuration = {
		enter: theme.transitions.duration.enteringScreen,
		exit: theme.transitions.duration.leavingScreen
	};

	if (props.isEdit)
		return (
			<>
				{!props.isAdd && (
					<Fade
						in
						timeout={transitionDuration}
						style={{ transitionDelay: `${transitionDuration.exit}ms` }}
						unmountOnExit
					>
						<Fab className="m-4" variant="extended" onClick={props.fabProps.switchEdit}>
							<Icon className="mr-4" icon="undo-variant" />
							{t('DIALOG_ACTION_CANCEL')}
						</Fab>
					</Fade>
				)}
				<Fade
					in
					timeout={transitionDuration}
					style={{ transitionDelay: `${transitionDuration.exit}ms` }}
					unmountOnExit
				>
					<Fab className="m-4" variant="extended" color="secondary" type="submit" form="detailsPageContent">
						<Icon className="mr-4" icon="content-save" />
						{t('DIALOG_ACTION_SAVE')}
					</Fab>
				</Fade>
			</>
		);

	return <PageFab fab={props.fab} fabProps={props.fabProps} currentTabId={props.currentTabId} />;
}
